import { useTranslation } from 'react-i18next';
import { textColor } from '../../theming';
import { monoTextStyle, mutedSmallStyle } from './vinExtractionStyles';

/**
 * How the accepted VIN compares with the VIN the car had before the batch: "Same as before", or the earlier VIN
 * when they differ. Nothing when there was nothing to compare (no earlier VIN, or no VIN accepted).
 */
const PreviousVinNote = ({ car }) => {
    const { t } = useTranslation('vinExtraction');

    if (car.previousVinMatch === true) return <span style={mutedSmallStyle}>{t('cars.previousVin.matches')}</span>;
    if (car.previousVinMatch !== false) return null;

    return (
        <span style={{ ...mutedSmallStyle, color: textColor.warning }}>
            {t('cars.previousVin.differs')} <span style={monoTextStyle}>{car.previousVin}</span>
        </span>
    );
};

export default PreviousVinNote;
